import { cn } from '@/lib/utils';
import type { PickupInvestorPricingRow } from './pickupInvestorPricing';
import { pickupInvestorPricingRankState } from './pickupInvestorPricingPresentation';

interface PickupInvestorRankChipProps {
  row: PickupInvestorPricingRow;
  className?: string;
}

export function PickupInvestorRankChip({
  row,
  className
}: PickupInvestorRankChipProps) {
  const state = pickupInvestorPricingRankState(row);
  return (
    <span
      data-pickup-investor-rank-state={state}
      className={cn(
        'inline-flex h-[18px] w-[18px] shrink-0 items-center justify-center rounded-sm font-mono text-[9.5px] font-bold tabular-nums',
        state === 'unanswered' && 'bg-primary text-primary-foreground',
        state === 'answered' && 'bg-muted text-muted-foreground',
        state === 'unranked' && 'bg-transparent text-border',
        className
      )}
    >
      {row.rank ?? '·'}
    </span>
  );
}
